// @router
import { RouteConfig } from "vue-router";

const newContainer = () => import("@/layouts/Default.vue");
const routerParrent = () => import("@/components/base/routerParrent.vue");
import searchQuestionSuggest from "./../views/questionSuggest/searchQuestionSuggest.vue";
import myQuestionSuggest from "./../views/questionSuggest/myQuestionSuggest.vue";
import editQuestionSuggest from "./../views/questionSuggest/editQuestionSuggest.vue";
import interviewKhelpPage from "./../views/help/interviewKhelpPage.vue";
import interviewVhelpPage from "./../views/help/interviewVhelpPage.vue";
import interviewMhelpPage from "./../views/help/interviewMhelpPage.vue";
import interviewPhelpPage from "./../views/help/interviewPhelpPage.vue";
import searchInterviewLocation from "./../views/interviewLocation/searchInterviewLocation.vue";
import searchInterviewLocationPlan from "./../views/interviewLocationPlan/searchInterviewLocationPlan.vue";
import placeIninterviewLocationPlan from "./../views/interviewLocationPlan/placeIninterviewLocationPlan.vue";
import searchInterviewSeniorMaster from "./../views/interviewSeniorMaster/searchInterviewSeniorMaster.vue";
import searchInterviewDoing from "./../views/interviewDoing/searchInterviewDoing.vue";
import searchInterviewAccepting from "./../views/interviewAccepting/searchInterviewAccepting.vue";
import searchInterviewPlaningShow from "./../views/interviewPlaningShow/searchInterviewPlaningShow.vue";
import searchInterviewLocationPerson from "./../views/interviewLocationPerson/searchInterviewLocationPerson.vue";
import searchInterviewLocationAudience from "./../views/interviewLocationAudience/searchInterviewLocationAudience.vue";
import searchScheduleInterviewLocation from "./../views/scheduleInterviewLocation/searchScheduleInterviewLocation.vue";
import searchInterviewDone from "./../views/interviewDone/searchInterviewDone.vue";
import searchInterviewReady from "./../views/InterviewReady/searchInterviewReady.vue";
import reportCard from "./../views/reportCard/index.vue";

export const interviewRoutes: RouteConfig[] = [
  {
    path: "/interview",
    name: "dynamic_home",
    meta: {
      label: "خانه",
      requiresAuth: true,
    },
    component: newContainer,
    children: [
      {
        path: "interview_v_help",
        name: "interview_v_help",
        component: interviewVhelpPage,
        meta: {
          label: "راهنما",
          requiresAuth: true,
        },
      },
      {
        path: "interview_k_help",
        name: "interview_k_help",
        component: interviewKhelpPage,
        meta: {
          label: "راهنما",
          requiresAuth: true,
        },
      },
      {
        path: "interview_m_help",
        name: "interview_m_help",
        component: interviewMhelpPage,
        meta: {
          label: "راهنما",
          requiresAuth: true,
        },
      },
      {
        path: "interview_p_help",
        name: "interview_p_help",
        component: interviewPhelpPage,
        meta: {
          label: "راهنما",
          requiresAuth: true,
        },
      },
      {
        path: "question-suggest",
        name: "question-suggest",
        redirect: "/interview/question-suggest/list",
        component: routerParrent,
        meta: {
          label: "سؤال‌ها",
          requiresAuth: true,
        },
        children: [
          {
            path: "list",
            name: "question_suggestion",
            component: searchQuestionSuggest,
            meta: {
              label: "سؤال‌های پیشنهادی",
              requiresAuth: true,
            },
          },
          {
            path: "edit/:id",
            name: "edit_question_suggest",
            component: editQuestionSuggest,
            meta: {
              label: "ویرایش سؤال‌های پیشنهادی",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "my-question-suggest",
        name: "my-question-suggest",
        redirect: "/interview/my-question-suggest/list",
        component: routerParrent,
        meta: {
          label: "سؤال‌ها",
          requiresAuth: true,
        },
        children: [
          {
            path: "list",
            name: "my_question_suggestion",
            component: myQuestionSuggest,
            meta: {
              label: "سؤال‌های پیشنهادی من",
              requiresAuth: true,
            },
          },
          {
            path: "edit/:id",
            name: "edit-my-question-suggest",
            component: editQuestionSuggest,
            meta: {
              label: "ویرایش سؤال‌های پیشنهادی من",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "interview-location",
        name: "interview_location",
        redirect: "/interview/interview-location/list",
        component: routerParrent,
        meta: {
          label: "مصاحبه",
          requiresAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: "list",
            name: "search_Interview_location",
            component: searchInterviewLocation,
            meta: {
              label: "لیست مکان مصاحبه",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "interview-location-plan",
        name: "interview_location_plan",
        redirect: "/interview/interview-location-plan/list",
        component: routerParrent,
        meta: {
          label: "مصاحبه",
          requiresAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: "list",
            name: "interview-location-plan-list",
            component: searchInterviewLocationPlan,
            meta: {
              label: "زمانبندی و تعیین ظرفیت مکان‌های مصاحبه",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: "placeLocationPlan/:id",
            name: "placeIninterviewLocationPlan",
            component: placeIninterviewLocationPlan,
            meta: {
              label: "ظرفیت مکان‌های مصاحبه",
              requiresAuth: true,
            },
          },
          {
            path: "interviewLocationAudience/:id",
            name: "interviewLocationAudience",
            component: searchInterviewLocationAudience,
            meta: {
              label: "تعیین متقاضی مصاحبه",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: "InterviewLocationPerson/:id",
            name: "searchInterviewLocationPerson",
            component: searchInterviewLocationPerson,
            meta: {
              label: "تعیین استاد مصاحبه برای مکان/زمان",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "interviewSeniorMaster",
        name: "interviewSeniorMaster",
        redirect: "/interview/interviewSeniorMaster/search",
        component: routerParrent,
        meta: {
          label: "مصاحبه",
          requiresAuth: true,
        },
        children: [
          {
            path: "search",
            name: "searchInterviewSeniorMaster",
            component: searchInterviewSeniorMaster,
            meta: {
              label: "رابطه بین استاد ارشد مصاحبه و استاد مصاحبه",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "interviewDoing",
        name: "interview_doing",
        redirect: "/interview/interviewDoing/search",
        component: routerParrent,
        meta: {
          label: "مصاحبه",
          requiresAuth: true,
        },
        children: [
          {
            path: "search",
            name: "searchInterviewDoing",
            component: searchInterviewDoing,
            meta: {
              label: "انجام مصاحبه",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "interview-accepting",
        name: "interview_accepting",
        redirect: "/interview/interview-accepting/search",
        component: routerParrent,
        meta: {
          label: "مصاحبه",
          requiresAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: "search",
            name: "searchInterviewAccepting",
            component: searchInterviewAccepting,
            meta: {
              label: "پذیرش مصاحبه",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "interview-ready",
        name: "interview_ready",
        redirect: "/interview/interview-ready/list",
        component: routerParrent,
        meta: {
          label: "مصاحبه ",
          requiresAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: "list",
            name: "searchInterviewReady",
            component: searchInterviewReady,
            meta: {
              label: "آماده مصاحبه",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "InterviewPlaningShow",
        name: "interview_planing_show",
        redirect: "/interview/InterviewPlaningShow/search",
        component: routerParrent,
        meta: {
          label: "مصاحبه",
          requiresAuth: true,
        },
        children: [
          {
            path: "search",
            name: "searchInterviewPlaningShow",
            component: searchInterviewPlaningShow,
            meta: {
              label: "مشاهده زمان مصاحبه",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "scheduleInterviewLocation",
        name: "schedule_interview_location",
        redirect: "/interview/scheduleInterviewLocation/search",
        component: routerParrent,
        meta: {
          label: "مصاحبه",
          requiresAuth: true,
        },
        children: [
          {
            path: "search",
            name: "searchScheduleInterviewLocation",
            component: searchScheduleInterviewLocation,
            meta: {
              label: " زمان مصاحبه",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "interview-done",
        name: "interview_done",
        // component: routerParent,
        redirect: "/interview/interview-done/list",
        meta: {
          label: "مصاحبه",
          requiresAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: "list",
            name: "interview-done-list",
            // component: interviewDoneList,
            meta: {
              label: "مصاحبه‌های انجام شده",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "",
        name: "interview_report_card_parent",
        redirect: "/interview/reportCard",
        component: routerParrent,
        meta: {
          label: "مصاحبه",
          requiresAuth: true,
        },
        children: [
          {
            path: "reportCard",
            name: "interview_report_card",
            component: reportCard,
            meta: {
              label: "مشاهده کارنامه آزمون شفاهی",
              requiresAuth: true,
            },
          },
          {
            path: "reportCard/:code",
            name: "interview_final_result",
            component: reportCard,
            meta: {
              label: "مشاهده کارنامه آزمون شفاهی",
              requiresAuth: true,
            },
          },
        ],
      },
    ],
  },
];
